import { useEffect, useRef, useState } from 'react'
import throttle from '@/utils/throttle'

const useScrollDirection = (root: HTMLElement) => {
  const prevScrollY = useRef(0)
  const [direction, setDirection] = useState<'up' | 'down'>('up')

  useEffect(() => {
    if (!root) return

    const handler = throttle(() => {
      const scrollY = root.scrollTop

      const direction = prevScrollY.current < scrollY ? 'down' : 'up'
      prevScrollY.current = scrollY

      setDirection(direction)
    }, 100)

    root.addEventListener('scroll', handler)

    return () => {
      root.removeEventListener('scroll', handler)
    }
  }, [root])

  return direction
}

export default useScrollDirection
